// Dominio: ciclo de cierre de facturación. Incluye pasarelas al facturador
// (documentos) y a mediciones (medidores), exclusivas de este flujo.

const defaultHeaders = new Headers();

defaultHeaders.append("Content-Type", "application/json");

const fetchOptions = (method = "GET", body = null) => {
  const options = {
    method,
    headers: defaultHeaders,
    credentials: "include",
    redirect: "follow",
  };
  if (body) {
    options.body = body;
  }
  return options;
};

export const getEmpresas = async (baseUrl) => {
  const response = await fetch(`${baseUrl}getAllEmpresas`, fetchOptions());
  if (!response.ok) throw new Error("Error al obtener las empresas");
  const data = await response.json();
  if (Array.isArray(data.empresas)) return data.empresas;
  throw new Error("Formato de respuesta inesperado");
};

export const getPeriodoFacturacionByPeriodo = async (baseUrl, periodo, empresa) => {
  const response = await fetch(
    `${baseUrl}getPeriodoFacturacionByPeriodo?periodo=${periodo}&empresa=${empresa}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

// Exportación del ciclo de cierre a Excel (generada en el backend)
export const exportCierreFacturacion = async (baseUrl, { periodo, empresa, valorUf }) => {
  const response = await fetch(
    `${baseUrl}exportCierreFacturacion?periodo=${encodeURIComponent(
      periodo
    )}&empresa=${encodeURIComponent(empresa)}&valorUf=${valorUf}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(`Error al exportar el cierre (${response.status})`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Periodo_Facturacion.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getCabeceraCierre = async (baseUrl, empresa, periodo) => {
  const response = await fetch(
    `${baseUrl}getCabeceraCierreByIdEmpresa?empresa=${empresa}&periodo=${periodo}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const ejecutarCierre = async (baseUrl, { empresa, idUsuario, periodo, valorUf }) => {
  const response = await fetch(
    `${baseUrl}ejecutarCierre?empresa=${encodeURIComponent(
      empresa
    )}&idUsuario=${idUsuario}&periodo=${encodeURIComponent(
      periodo
    )}&valorUf=${valorUf}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const validarCierre = async (baseUrl, { empresa, idUsuario, periodo }) => {
  const response = await fetch(
    `${baseUrl}validarCierre?empresa=${encodeURIComponent(
      empresa
    )}&idUsuario=${idUsuario}&periodo=${encodeURIComponent(periodo)}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const getDetalleCobroByIdPeriodoFacturacion = async (baseUrl, idPeriodo) => {
  const response = await fetch(
    `${baseUrl}getDetalleCobroByIdPeriodoFacturacion?idPeriodo=${idPeriodo}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const marcarEnvioAsignacion = async (baseUrl, idPeriodoFacturacion, idUsuarioSender) => {
  const response = await fetch(
    `${baseUrl}marcarEnvioAsignacion?idPeriodoFacturacion=${idPeriodoFacturacion}&idUsuarioSender=${idUsuarioSender}`,
    fetchOptions("PUT")
  );
  if (!response.ok) {
    throw new Error(`Error al marcar envío (${response.status})`);
  }
  return response.json();
};

export const getEnviadoValueById = async (baseUrl, idPeriodoFacturacion) => {
  const response = await fetch(
    `${baseUrl}getEnviadoValueById?idPeriodoFacturacion=${idPeriodoFacturacion}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(`Error al verificar enviado: ${response.status}`);
  }
  return response.json();
};

export const actualizarMediciones = async (baseUrl, { periodo, empresa, valorUf }, consumoMedidores) => {
  const response = await fetch(
    `${baseUrl}actualizarMediciones?periodo=${periodo}&empresa=${empresa}&valorUf=${valorUf}`,
    fetchOptions("POST", JSON.stringify(consumoMedidores))
  );
  if (!response.ok) {
    throw new Error(`Failed to update mediciones! status: ${response.status}`);
  }
  return true;
};

// PASARELA FACTURADOR: guarda los documentos de venta generados por el cierre
export const guardarDetalleDocumento = async (urlDocumentos, payloadMasivo) => {
  // Formato total a 2 decimales (requisito del facturador)
  let cuerpo = JSON.stringify(payloadMasivo);
  cuerpo = cuerpo.replace(/("total":)(\d+)(?=[,}])/g, "$1$2.0");

  const response = await fetch(`${urlDocumentos}guardarDetalleDocumento`, {
    method: "POST",
    headers: defaultHeaders,
    body: cuerpo,
    redirect: "follow",
    credentials: "include", // importante para enviar la cookie SSO al otro subdominio
  });
  return response;
};

// PASARELA MEDIDORES: obtiene las mediciones del período
export const getDetallePeriodo = async (urlMedidores, periodoMedicion) => {
  const response = await fetch(
    `${urlMedidores}getDetallePeriodo?periodoMedicion=${periodoMedicion}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch consumo medidores! status: ${response.status}`
    );
  }
  return response.json();
};
